import { useEffect } from 'react';
import { useOrganization } from '../contexts/OrganizationContext';
import { identifyOrganization } from '../lib/analytics/posthog';

/** Associa a organização ativa ao perfil PostHog (requer OrganizationProvider). */
export function usePostHogOrganizationAnalytics(): void {
  const { currentOrganization } = useOrganization();

  useEffect(() => {
    if (!currentOrganization?.id) return;

    identifyOrganization(currentOrganization.id, {
      name: currentOrganization.name,
      slug: currentOrganization.slug,
      plan: currentOrganization.plan,
      status: currentOrganization.status,
      role: currentOrganization.role,
    });
  }, [currentOrganization]);
}
